<script lang="ts">
  import VerticalNav from '$shared/molecules/VerticalNav/VerticalNav.svelte';
  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import ScrollContainer from './_partial/ScrollContainer.svelte';

  interface Props {
    loading?: boolean;
    invert?: boolean;
    hasCount?: boolean;
    countMap?: any;
    activeNav?: string;
    navList?: VerticalNavType[];
    navChildren?: VerticalNavType[];
    additionalNavs?: VerticalNavType[];
    childAdditionalNavs?: VerticalNavType[];
    navChildActive?: string;
    navChildrenTitle?: string;
    expandable?: boolean;
    nav?: import('svelte').Snippet;
    children?: import('svelte').Snippet;
    onclickNav?: (detail: any) => void;
    onclickchildnav?: (detail: any) => void;
    onclickchildnavback?: () => void;
    onclickadditionalnav?: (nav: VerticalNavType) => void;
    onclickchildadditionalnav?: (nav: VerticalNavType) => void;
    onpagescroll?: (payload: { id: string }) => void;
  }

  let {
    loading = false,
    invert = false,
    hasCount = false,
    countMap = {},
    activeNav = '',
    navList = [],
    navChildren = [],
    additionalNavs = [],
    childAdditionalNavs = [],
    navChildActive = '',
    navChildrenTitle = '',
    expandable = false,
    nav,
    children,
    onclickNav,
    onclickchildnav,
    onclickchildnavback,
    onclickadditionalnav,
    onclickchildadditionalnav,
    onpagescroll
  }: Props = $props();

  let expand = $state(false);

  const onClickNav = (nav: VerticalNavType) => {
    onclickNav?.(nav);
  };

  const onClickChildNav = (nav: VerticalNavType) => {
    onclickchildnav?.(nav);
  };

  const onClickChildBack = () => {
    onclickchildnavback?.();
  };

  const onClickToggleExpand = (): void => {
    expand = !expand;
  };
</script>

<div class="comp-vnav-view" class:invert class:expand>
  <div class="vertical-nav">
    {#if loading}
      <div class="nav-loader">
        <Loader count={2} />
      </div>
    {:else}
      <div class="nav-container">
        <VerticalNav
          {hasCount}
          {countMap}
          list={navList}
          active={activeNav}
          children={navChildren}
          childActive={navChildActive}
          childrenTitle={navChildrenTitle}
          {additionalNavs}
          {childAdditionalNavs}
          onclick={onClickNav}
          onclickchild={onClickChildNav}
          onclickchildback={onClickChildBack}
          onclickadditionalnav={onclickadditionalnav}
          onclickchildadditionalnav={onclickchildadditionalnav}
        />
        {@render nav?.()}
      </div>
    {/if}
    {#if expandable}
      <button class="expand-btn" type="button" onclick={onClickToggleExpand}
        ><Icon value={(expand && 'icon-chevron-right') || 'icon-chevron-left'} /></button
      >
    {/if}
  </div>
  <ScrollContainer {invert} {onpagescroll}>{@render children?.()}</ScrollContainer>
</div>

<style>
  .comp-vnav-view {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: auto;
    background-color: var(--grey-bg-light);
  }

  .comp-vnav-view.expand .vertical-nav {
    margin-left: -240px;
  }

  .vertical-nav {
    width: 264px;
    flex-basis: 264px;
    flex-shrink: 0;
    flex-grow: 0;
    height: 100%;
    background-color: #fff;
    padding-top: 40px;
    position: relative;
    border-right: 1px solid rgba(0, 0, 0, 0.07);
    transition: margin 0.2s ease-in-out;
  }
  .nav-loader {
    width: 100%;
  }
  .nav-container {
    padding: 0px 24px 24px 24px;
    height: 100%;
    overflow: auto;
  }
  .comp-vnav-view.invert .vertical-nav {
    background-color: var(--grey-bg);
  }

  .expand-btn {
    position: absolute;
    top: 7px;
    left: 100%;
    background-color: #fff;
    border: 1px solid #eee;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, 0);
    opacity: 0;
  }
  .vertical-nav:hover .expand-btn {
    opacity: 1;
  }
</style>
